import styled from "styled-components";
import { textoOscuro } from "./UI/variables";
import { useEffect, useState } from "react";

const StyledSelect = styled.select`
  width: 328px;
  height: 36px;
  border-radius: 5px;
  margin: 8px 0px 8px 0px;
  border-color: ${textoOscuro};
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
`;
const DesplegableTipologiaEspacio = ({ onSeleccionChange, tipoAlquiler }) => {
  const tiposDeEspacio = ["Habitación", "Departamento"];
  const [valorSeleccionado, setValorSeleccionado] = useState("");

  const manejoCambioSeleccion = (e) => {
    const valor = e.target.value;
    setValorSeleccionado(valor);
    onSeleccionChange(valor);
  };
  // este useEffect solo funciona cuando se recibe mediante props el valor de "tipoAlquiler", y esto solo ocurre cuando editamos una habitacion.
  useEffect(() => {
    if (tipoAlquiler) {
      setValorSeleccionado(tipoAlquiler);
    }
  }, [tipoAlquiler]);

  return (
    <StyledSelect
      value={valorSeleccionado}
      onChange={manejoCambioSeleccion}
      required
    >
      <option value="" disabled>
        Selecciona aqui
      </option>
      {tiposDeEspacio.map((tipo, index) => (
        <option value={tipo} key={index}>
          {tipo}
        </option>
      ))}
    </StyledSelect>
  );
};
export default DesplegableTipologiaEspacio;
